import React, { useEffect } from 'react';

const TerritoryInfo = ({ highwayTerritory, cantonTerritory, selectedCity, selectedCanton, selectedRegion, selectedArea, handleEditingCancelClick }) => {

  // отслежываем изменения highwayTerritory, cantonTerritory
  useEffect(() => {
    handleEditingCancelClick();
  }, [highwayTerritory, cantonTerritory]);


  if (highwayTerritory || cantonTerritory) {
    return (
      <div className="divCurrentTerritory" style={{padding:'10px', fontSize:'14px'}}>
        <label style={{ color: '#d1d1d1', textShadow: '2px 2px 4px rgb(58, 58, 58)'}}>Выбранная территория</label>
        <hr style={{margin: '5px'}} />
        {highwayTerritory && (
          <label style={{ color: 'white',textShadow: '2px 2px 4px #3d3d3d' }}>Территория: <span style={{ color: '#fcc205', textShadow: '2px 2px 4px rgb(44, 44, 44)' }}>{selectedCity}</span></label>
        )}
        {cantonTerritory && (
          <>
            <label style={{ color: 'white', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Округ: <span style={{ color: '#fcc205',textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{selectedCanton}</span></label>
           
            {selectedRegion && selectedRegion !== "null" &&(
              <>
                <br/>
                <span style={{ color: 'white', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Регион: </span>
                <span style={{ color: '#fcc205', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{selectedRegion}</span>
              </>
            )}
           
            {selectedArea && selectedArea !== "null" && (
              <>
                <br/>
                <span style={{ color: 'white', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Ветка: </span>
                <span style={{ color: '#fcc205', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{selectedArea}</span>
              </>
            )}
          </>
        )}
      </div>
    );
  } else {
    return null;
  }
}

export default TerritoryInfo;